export default __webpack_public_path__ + "230d61331efc8e623d51ccbf4aad029f.png";